import { getOrCreateSocket } from "socket/socket";
import { store } from "store/store";

export const reorderCards = (oldIndex: number, newIndex: number) => {
  const socket = getOrCreateSocket();
  socket.emit("reorderCards", store.currentRoom, oldIndex, newIndex);
};
